import { PayloadAction } from '@reduxjs/toolkit';
import { call, put, select } from 'redux-saga/effects';

import { $httpRootApi, getCancelRequestSource, yieldFailureResponse, yieldSuccessResponse } from '@core/http-client';
import { lettingInsightsActions } from '@redux/reducers/insights/letting/lettingInsightsReducer';
import { lettingInsightsSelectors } from '@redux/selectors/insights/lettingInsights';
import {
  GetLettingInsightsRequestPayload,
  GetLettingInsightsResponse,
  LettingInsightsState,
} from '@redux/types/insights/letting/lettingInsightsTypes';
import { showNotification } from '@shared/components/notification';
import { getDefaultError, getQueriesAsSearch } from '@shared/utils/common';

export function* getLettingInsightsSaga(action: PayloadAction<GetLettingInsightsRequestPayload>) {
  const source = getCancelRequestSource();

  yield put(lettingInsightsActions.setListLoading(true));

  const { error, response }: GetLettingInsightsResponse = yield call(() =>
    $httpRootApi
      .get(`/transactions/lettings/statistics${getQueriesAsSearch(action.payload)}`, {
        cancelToken: source.token,
      })
      .then(yieldSuccessResponse)
      .catch(yieldFailureResponse)
  );

  if (response) {
    yield put(lettingInsightsActions.getListSuccess(response.data));
  } else if (error) {
    const errorMessage = getDefaultError(error.response?.data?.message || error.message);

    // Set the societies invalid flag
    if (error.response?.status === 403) {
      yield put(lettingInsightsActions.setListSocietiesInvalid(true));
    }

    // Show error notification
    showNotification(errorMessage, 'error');

    // Set the message / errors list
    yield put(lettingInsightsActions.getListFailure(errorMessage));
  }

  const { loading }: LettingInsightsState = yield select(lettingInsightsSelectors.getState);
  if (loading) {
    source.cancel();
  }
}
